/// <amd-module name="Wit/WorkItem/Service/index" />
export { CreationMode, IWorkItemService } from "./Contracts";
